import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'proofs'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getProofsPost (payload) {
    return Client.post(`${resource}/get/get_proofs_post`, parseFilters(payload))
      .then(response => response.data)
  },
  getProof (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  getProofReviewers (id, filters) {
    return Client.get(`${resource}/${id}/proof_reviewers?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  createProofReviewer (payload, id) {
    return Client.post(`${resource}/${id}/proof_reviewers`, payload)
      .then(response => response.data)
  },
  updateProofReviewer (payload, proofId, id) {
    return Client.put(`${resource}/${proofId}/proof_reviewers/${id}`, payload)
      .then(response => response.data)
  },
  createProofComment (payload, id) {
    return Client.post(`${resource}/${id}/proof_comments`, payload)
      .then(response => response.data)
  },
  getProofComments (id, filters) {
    return Client.get(`${resource}/${id}/proof_comments?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  signProofImages (id, pageCount, bookType) {
    return Client.get(`${resource}/${id}/s3_sign_flip_images?pages=${pageCount}&type_book=${bookType}&new_dashboard_override=true`)
      .then(response => response.data)
  },
  parseProofManifest (id) {
    return Client.get(`${resource}/${id}/s3_parse_manifest?new_dashboard_override=true`)
      .then(response => response.data)
  },
  getEpubLink (id) {
    return Client.get(`${resource}/${id}/epub_link`)
      .then(response => response.data)
  },
  rejectMementoProof (id, reason) {
    return Client.post(`${resource}/memento/${id}/cancel`, { reason })
      .then(response => response.data)
  },
  rejectPlicProof (id) {
    return Client.post(`${resource}/plic/reject`, { id })
      .then(response => response.data)
  },
  sendIntegromatCall (payload) {
    return Client.post(`${resource}/integromat/send`, payload)
      .then(response => response.data)
  },
  readyToOrder (studioId, year) {
    return Client.get(`${resource}/list/ready_to_order?year=${year}&parentId=${studioId}`)
      .then(response => response.data)
  },
  resubmissionRequired (studioId, year) {
    return Client.get(`${resource}/list/resubmission_required?year=${year}&parentId=${studioId}`)
      .then(response => response.data)
  }
}
